import { Alert, Stack } from '@mui/material';
import React from 'react';

interface ServerErrorAlertProps {
  errors: string[];
}

export default function ServerErrorAlert({ errors = [] }: ServerErrorAlertProps) {
  return (
    <Stack sx={{ width: '100%', marginY: 1 }} spacing={1}>
      {errors.map((e) => (
        <Alert key={e} severity="error" data-testid="error-message">
          {e}
        </Alert>
      ))}
    </Stack>
  );
}
